import { TrendingHsCode } from '@/modules/hs/types/homepage.types'

const baseURL =
  process.env.NEXT_PUBLIC_API_HOST_PORT || 'http://localhost:4444/api'

export async function getHsCodeListDetail(
  hsCodes: string[],
): Promise<TrendingHsCode[]> {
  const hsCodesParam = hsCodes.join(',')
  const response = await fetch(
    `${baseURL}/hscode/list-detail?hsCodes=${hsCodesParam}`,
    {
      cache: 'no-store', // Always get fresh data
    },
  )

  if (!response.ok) {
    throw new Error('Failed to fetch trending HS codes')
  }

  return response.json()
}
